<template lang="pug">
.summary-page
  .summary-top
    .summary-top__info.info-summary
      .info-summary__ava К
      .info-summary__info
        .info-summary__title Меладзе в Рыбинске
        .info-summary__text Рыбинск, Дворец спорта "Полет", 16 октября, 19:00
    router-link(to='preview').btn Посмотреть виджет
    a(href='#' @click.prevent="onSidebar" v-show="this.windowWidth < 1200").sidebar-gamb
      svgicon(name='gamb')
  .summary-info
    .summary-info__item.item-summary
      template(v-if="this.windowWidth > 767")
        .item-summary__info 
          a(href='#').item-summary__info-title 
            span Доход
          .item-summary__info-text Поступило на счет сегодня
        .item-summary__item.item-summary__item--total
          .item-summary__title Всего
          .item-summary__text 1 108 375 Р
        .item-summary__item.item-summary__item--today
          .item-summary__title Сегодня
          .item-summary__text 15 500 Р
        .item-summary__item.item-summary__item--yesteday
          .item-summary__title Вчера
          .item-summary__text 27 500 Р
        .item-summary__item.item-summary__item--week
          .item-summary__title За неделю
          .item-summary__text 188 500 Р 
            .item-summary__dynamic.item-summary__dynamic--up +10%
      template(v-else)
        .item-summary__info 
          a(href='#').item-summary__info-title 
            span Доход
          .item-summary__item.item-summary__item--total
            .item-summary__text 1 108 375 Р
          .item-summary__item.item-summary__item--today
            .item-summary__title cегодня
            .item-summary__text 15 500 Р
      .item-summary__graph
        .info-graph
          highcharts(:options="Graph1")
    .summary-info__item.item-summary
      template(v-if="this.windowWidth > 767")
        .item-summary__info 
          a(href='#').item-summary__info-title 
            span Заказы
          .item-summary__info-text Кол-во оплаченных заказов
        .item-summary__item.item-summary__item--total
          .item-summary__title Всего
          .item-summary__text 630
        .item-summary__item.item-summary__item--today
          .item-summary__title Сегодня
          .item-summary__text 21
        .item-summary__item.item-summary__item--yesteday
          .item-summary__title Вчера
          .item-summary__text 25
        .item-summary__item.item-summary__item--week
          .item-summary__title За неделю
          .item-summary__text 151 
            .item-summary__dynamic.item-summary__dynamic--down -5%
      template(v-else)
        .item-summary__info 
          a(href='#').item-summary__info-title 
            span Заказы
          .item-summary__item.item-summary__item--total
            .item-summary__text 630
          .item-summary__item.item-summary__item--today
            .item-summary__title cегодня
            .item-summary__text 21
      .item-summary__graph
        .info-graph
          highcharts(:options="Graph2")
    .summary-info__item.item-summary
      template(v-if="this.windowWidth > 767")
        .item-summary__info 
          router-link(to='sales').item-summary__info-title 
            span Продажи билетов
          .item-summary__info-text Кол-во оплаченных билетов
        .item-summary__item.item-summary__item--total
          .item-summary__title Всего
          .item-summary__text 1 071 из 2 448
        .item-summary__item.item-summary__item--today
          .item-summary__title Сегодня
          .item-summary__text 33
        .item-summary__item.item-summary__item--yesteday
          .item-summary__title Вчера
          .item-summary__text 35
        .item-summary__item.item-summary__item--week
          .item-summary__title За неделю
          .item-summary__text 175 
            .item-summary__dynamic.item-summary__dynamic--up +7%
      template(v-else)
        .item-summary__info 
          a(href='#').item-summary__info-title 
            span Продажи билетов
          .item-summary__item.item-summary__item--total
            .item-summary__text 1 071 из 2 448
          .item-summary__item.item-summary__item--today
            .item-summary__title cегодня
            .item-summary__text 33
      .item-summary__graph
        .info-graph
          highcharts(:options="Graph3")
  .summary-cols
    .summary-col 
      .summary-statistics
        router-link(to='sales').summary-statistics__link Каналы продаж
        .summary-statistics__text Источники переходов для оплаченных заказов
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Кассиры
            .item-statistics__percent 35,5%
            .item-statistics__count 468 000 Р
          .item-statistics__progress
            .item-statistics__active.pb-blue(data-percent='35.5%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Яндекс.Директ
            .item-statistics__percent 18,7%
            .item-statistics__count 123 000 Р
          .item-statistics__progress
            .item-statistics__active.pb-green(data-percent='18.7%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Вконтакте
            .item-statistics__percent 12%
            .item-statistics__count 98 000 Р
          .item-statistics__progress
            .item-statistics__active.pb-fiolet(data-percent='12%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Google Adwords
            .item-statistics__percent 9%
            .item-statistics__count 73 000 Р
          .item-statistics__progress
            .item-statistics__active.pb-yellow(data-percent='9%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Прочее
            .item-statistics__percent 6%
            .item-statistics__count 55 500 Р
          .item-statistics__progress
            .item-statistics__active.pb-orange(data-percent='6%')
    .summary-col 
      .summary-statistics
        .summary-statistics__title Воронка продаж
        .summary-statistics__text Всего переходов
          span 22 678
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Открыт виджет
            .item-statistics__percent 82,5%
            .item-statistics__count 15 097
          .item-statistics__progress
            .item-statistics__active.pb-blue(data-percent='82.5%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Билет в корзине
            .item-statistics__percent 13,5%
            .item-statistics__count 5 567
          .item-statistics__progress
            .item-statistics__active.pb-green(data-percent='13.5%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Заказ оплачен
            .item-statistics__percent 12%
            .item-statistics__count 630
          .item-statistics__progress
            .item-statistics__active.pb-fiolet(data-percent='12%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Заказ отменен
            .item-statistics__percent 2,6%
            .item-statistics__count 117
          .item-statistics__progress
            .item-statistics__active.pb-yellow(data-percent='2.6%')
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__title Возврат билетов
            .item-statistics__percent 0,1%
            .item-statistics__count 2
          .item-statistics__progress
            .item-statistics__active.pb-orange(data-percent='0.1%')
    .summary-col 
      .summary-statistics
        a(href='#').summary-statistics__link Просмотры виджета
        .summary-statistics__text Источники трафика (каналы)
        .summary-statistics__graph
          .summary-graph
            highcharts(:options="summaryGraph")
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__point.item-statistics__point--green
            .item-statistics__title Яндекс.Директ
            .item-statistics__count 6 567 (42%)
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__point.item-statistics__point--blue
            .item-statistics__title Вконтакте
            .item-statistics__count 5 234 (30%)
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__point.item-statistics__point--yellow
            .item-statistics__title Google Adwords
            .item-statistics__count 4 787 (22%)
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__point.item-statistics__point--orange
            .item-statistics__title Кассиры
            .item-statistics__count 855 (5%)
        .summary-statistics__item.item-statistics
          .item-statistics__top
            .item-statistics__point.item-statistics__point--fiolet
            .item-statistics__title Прочие
            .item-statistics__count 835 (5%)
            
      
        

</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      Graph1: {
        chart: {
          type: 'area',
          height: 65,
          margin: 0,
        },
        credits: false,
        title: false,
        xAxis: {
          type: 'datetime',
          visible: false,
        },
        yAxis: {
          title: false,
          visible: false,
        },
        legend: false,
        plotOptions: {
          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [0, '#008cff'],
                [1, 'rgba(255,255,255,0']
              ]
            },
            marker: false,
            lineWidth: 1,
            threshold: null
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0,
          padding: 10,
          xDateFormat: '%d.%m.%y %A',
          useHTML: true,
          headerFormat: '{point.key}<br>',
          pointFormat: '<b>{series.name} {point.y} Р</b>',
          valueDecimals: 0
        },
        series: [{
          name: 'Доход',
          data: [
            [1513036800000, 22000], 
            [1513123200000, 30000], 
            [1513209600000, 24000], 
            [1513296000000, 18000], 
            [1513555200000, 23000], 
            [1513641600000, 30000], 
            [1513728000000, 20000], 
            [1513814400000, 2000], 
            [1513900800000, 18000], 
            [1514332800000, 22000], 
            [1514419200000, 31000], 
            [1514505600000, 24000]
          ],
          color: '#008cff',
        }]
      },
      Graph2: {
        chart: {
          type: 'area',
          height: 65,
          margin: 0,
        },
        credits: false,
        title: false,
        xAxis: {
          type: 'datetime',
          visible: false,
        },
        yAxis: {
          title: false,
          visible: false,
        },
        legend: false,
        plotOptions: {
          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [0, '#78c076'],
                [1, 'rgba(255,255,255,0']
              ]
            },
            marker: false,
            lineWidth: 1,
            threshold: null
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0,
          padding: 10,
          xDateFormat: '%d.%m.%y %A',
          useHTML: true,
          headerFormat: '{point.key}<br>',
          pointFormat: '<b>{series.name} {point.y}</b>',
          valueDecimals: 0
        },
        series: [{
          name: 'Заказы',
          data: [
            [1513036800000, 25], 
            [1513123200000, 21], 
            [1513209600000, 18], 
            [1513296000000, 30], 
            [1513555200000, 10], 
            [1513641600000, 15], 
            [1513728000000, 19], 
            [1513814400000, 25], 
            [1513900800000, 17], 
            [1514332800000, 19], 
            [1514419200000, 22], 
            [1514505600000, 12]
          ],
          color: '#78c076',
        }]
      },
      Graph3: {
        chart: {
          type: 'area',
          height: 65,
          margin: 0,
        },
        credits: false,
        title: false,
        xAxis: {
          type: 'datetime',
          visible: false,
        },
        yAxis: {
          title: false,
          visible: false,
        },
        legend: false,
        plotOptions: {
          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [0, '#ff6633'],
                [1, 'rgba(255,255,255,0']
              ]
            },
            marker: false,
            lineWidth: 1,
            threshold: null
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0,
          padding: 10,
          xDateFormat: '%d.%m.%y %A',
          useHTML: true,
          headerFormat: '{point.key}<br>',
          pointFormat: '<b>{series.name} {point.y}</b>',
          valueDecimals: 0
        },
        series: [{
          name: 'Заказы',
          data: [
            [1513036800000, 35], 
            [1513123200000, 33], 
            [1513209600000, 30], 
            [1513296000000, 32], 
            [1513555200000, 20], 
            [1513641600000, 35], 
            [1513728000000, 19], 
            [1513814400000, 35], 
            [1513900800000, 30], 
            [1514332800000, 19], 
            [1514419200000, 32], 
            [1514505600000, 22]
          ],
          color: '#ff6633',
        }]
      },
      summaryGraph: {
        chart: {
          type: 'bar',
          height: 50,
          margin: 0,
        },
        credits: false,
        title: false,
        xAxis: {
          visible: false,
        },
        yAxis: {
          title: false,
          visible: false,
        },
        legend: false,
        plotOptions: {
          series: {
            stacking: 'percent',
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0,
          padding: 10,
          formatter: function () {
            return '<span style="color:'+this.series.color+'">●</span>'+ '  ' +'<b>' + this.series.name + ' ' + this.y + '</b>' ;
          }
        },
        series: [{
          name: 'Яндекс.Директ',
          data: [6567],
          color: '#78c076'
        }, {
          name: 'Вконтакте',
          data: [5234],
          color: '#008cff'
        }, {
          name: 'Google Adwords',
          data: [4787],
          color: '#ffcc00'
        }, {
          name: 'Кассиры',
          data: [855],
          color: '#ff6633'
        }, {
          name: 'Прочие',
          data: [835],
          color: '#9966cc'
        }]
      },
      windowWidth: null,
    }
  },
  mounted: function(){
    let elements = document.querySelectorAll('.item-statistics__active');
    for (let elem of elements) {
      let width = elem.getAttribute('data-percent');
      setTimeout( function(){
        elem.setAttribute('style', 'width: '+width)
      }, 300);
    }
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onSidebar',
    ]),
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  computed:{
    ...mapGetters([
      'sidebar',
    ]),
  },
}
</script>
<style lang="scss">
.summary-top{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
}
.info-summary{
  display: flex;
  align-items: center;
  margin-right: auto;
  &__ava{
    width: 70px;
    height: 70px;
    margin-right: 20px;
    overflow: hidden;
    text-align: center;
    align-items: center;
    background: #78c076;
    border-radius: 50%;
    color: #fff;
    font-size: 39px;
    font-weight: 700;
    line-height: 70px;
  }
  &__title{
    color: #161616;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  &__text{
    color: #161616;
    font-size: 16px;
  }
}
.summary-info{
  box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  background-color: #fff;
  margin-bottom: 30px;
}
.item-summary{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e4e4e4;
  border-top: none;
  padding: 10px 20px;
  &__item{
    margin-right: 20px;
    &--total{
      width: 115px;
    }
    &--today{
      width: 90px;
    }
    &--yesteday{
      width: 90px;
    }
    &--week{
      width: 115px;
    }
  }
  &__info{
    width: 260px;
    margin-right: 20px;
    &-title{
      color: #161616;
      font-size: 16px;
      font-weight: 700;
      text-decoration: none;
      display: block;
      span{
        border-bottom: 1px solid #161616;
        line-height: 22px;
      }
      &:hover span{
        border-bottom-color: transparent;
      }
    }
    &-text{
      color: #161616;
      font-size: 16px;
      margin-top: 10px;
    }
  }
  &__title{
    color: #161616;
    font-size: 14px;
    margin-bottom: 10px;
  }
  &__text{
    color: #161616;
    font-size: 16px;
    font-weight: 700;
  }
  &__dynamic{
    font-size: 14px;
    font-weight: 600;
    display: inline-block;
    &--up{
      color: #36b067;
    }
    &--down{
      color: #e67c27;
    }
  }
  .info-graph{
    width: 260px;
  }
} 
.summary-cols{
  display: flex;
  align-items: flex-start;
  margin: 0 -17px;
}
.summary-col{
  width: 33%;
  flex-grow: 1;
  margin-bottom: 30px;
  border: 1px solid #e4e4e4;
  background-color: #fff;
  padding: 25px;
  margin: 0 17px;
  &:hover{
    box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  }
}
.summary-statistics{
  &__link{
    color: #161616;
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    text-decoration: none;
    border-bottom: 1px solid #161616;
    &:hover{
      border-bottom-color: transparent;
    }
  }
  &__title{
    color: #161616;
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
  }
  &__text{
    color: #161616;
    font-size: 14px;
    line-height: 20px;
    margin-top: 15px;
    margin-bottom: 20px;
    display: flex;
    span{
      font-weight: 700;
      margin-left: auto;
    }
  }
  &__graph{
    margin-top: 20px;
    margin-bottom: 10px;
    .summary-graph{
      width: 100%;
    }
  }
}
.item-statistics{
  margin-bottom: 30px;
  &:last-child{
    margin-bottom: 0;
  }
  &__top{
    display: flex;
    margin-bottom: 10px;
    color: #161616;
    font-size: 14px;
  }
  &__point{
    width: 11px;
    height: 11px;
    background: #ccc;
    border-radius: 50%;
    margin-right: 10px;
    align-self: center;
    &--green{
      background-color: #78c076;
    }
    &--blue{
      background-color: #008cff;
    }
    &--yellow{
      background-color: #ffcc00;
    }
    &--orange{
      background-color: #ff6633;
    }
    &--fiolet{
      background-color: #9966cc;
    }
  }
  &__title{
    width: 50%;
  }
  &__count{
    font-weight: 700;
    margin-left: auto;
  } 
  &__progress{
    border-radius: 6px;
    background-color: #eee;
    position: relative;
    height: 11px;
  }
  &__active{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: 6px;
    background-color: #c2c2c2;
    width: 0;
    transition: width 0.5s linear;
    &.pb-blue{
      background-color: #008cff;
    }
    &.pb-green{
      background-color: #78c076;
    }
    &.pb-fiolet{
      background-color: #9966cc;
    }
    &.pb-yellow{
      background-color: #ffcc00;
    }
    &.pb-orange{
      background-color: #ff6633;
    }
  }
}
@media (max-width: 991px) {
  .item-summary{
    align-items: flex-start;
  }
  .item-summary__info {
    width: 100px;
    margin-right: 10px;
  }
  .item-summary__info-title{
    font-size: 14px;
  }
  .item-summary .info-graph{
    width: 170px;
  }
  .item-summary__info-text{
    display: none;
  }
  .item-summary__text{
    font-size: 14px;
  }
  .item-summary__item--total {
    width: 135px;
  }
  .summary-top .btn{
    flex-shrink: 0;
  }
  .summary-cols{
    flex-direction: column;
    margin: 0;
  }
  .summary-col{
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    margin-bottom: 30px;
  }
}
@media (max-width: 767px) {
  .activity-inner__content{
    padding: 30px 20px;
  }
  .summary-info{
    margin-right: -20px;
    border-right: none;
  }
  .summary-cols{
    margin-right: -20px;
    border-right: none;
  }
  .summary-col{
    border-right: none;
  }
  .item-summary{
    align-items: center;
    padding-right: 0;
    border-right: none;
  }
  .item-summary .info-graph{
    width: 250px;
  }
  .item-summary__info{
    width: auto;
    flex-grow: 1;
  }
  .item-summary__info-title{
    margin-bottom: 10px;
  }
  .item-summary__item--total{
    width: auto;
    margin-bottom: 10px;
    .item-summary__text{
      font-size: 22px;
    }
  }
  .summary-top{
    flex-wrap: wrap;
  }
  .info-summary{
    margin-bottom: 20px;
    align-items: flex-start;
    width: 100%;
    &__ava{
      flex-shrink: 0;
      width: 45px;
      height: 45px;
      line-height: 45px;
      margin-right: 10px;
      font-size: 24px;
    }
    &__title{
      font-size: 16px;
    }
    &__text{
      font-size: 14px;
      line-height: 20px;
    }
  }
}

@media (max-width: 479px) {
  .item-summary .info-graph{
    width: 120px;
  }
  .item-summary__item--total .item-summary__text{
    font-size: 20px;
  }
  .item-summary__item--total{
    margin-right: 0;
  }
}
</style>